module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Kassa\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26c7ddc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/CheckoutPage.vue
// module id = 925
// module chunks = 0